<template>
  <div
    class="d-flex-column justify-start align-start work_with_us_spacing gap-40"
  >
    <div class="d-flex-column justify-start align-start gap-24">
      <p
        class="regular-s font-family-2 t-orange caps"
        style="letter-spacing: 2.24px"
      >
        {{ $t("reviews.testimonials") }}
      </p>

      <h2 class="t-white title-h2 font-family-1 f-w-600">
        {{ $t("reviews.trusted_by_1")
        }}<span class="t-light-orange">{{ $t("reviews.trusted_by_4") }}</span
        >{{ $t("reviews.trusted_by_5") }}
      </h2>
    </div>

    <div class="testimonial_card_container">
      <ClientOnly>
        <swiper
          ref="swiperRef"
          @swiper="onSwiper"
          @slideChange="onSlideChange"
          :space-between="30"
          :slides-per-view="5"
          :centered-slides="centerLastSlide"
          :breakpoints="breakpoints"
        >
          <swiper-slide
            v-for="(booster, i) in boosterReviews"
            :key="booster.username"
          >
            <BoosterTestimonialCard
              :review="booster.review"
              :stars="booster.stars"
              :booster="{
                image: booster.image,
                avatar: booster.avatar,
                game: booster.game,
                username: booster.username,
              }"
            />
          </swiper-slide>
        </swiper>
      </ClientOnly>
    </div>
  </div>
</template>

<script setup>
import BoosterTestimonialCard from "./BoosterTestimonialCard.vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import { ref } from "vue";

const swiperRef = ref(null);
const centerLastSlide = ref(false);

const boosterReviews = ref([
  {
    image: "/images/work-with-us/booster_1.webp",
    avatar: "/images/avatars/avatar78.webp",
    game: "League of Legends",
    username: "League Booster",
    review:
      "As a gamer, I can't stress enough how much of a game changer the Boosting Market has been for me. It optimizes my system, ensuring that I get the best performance possible while I’m deep into my favorite titles. The interface is user-friendly, making it easy to adjust settings on the fly. I’ve noticed a significant reduction in lag and frame drops",
    stars: 5,
  },
  {
    image: "/images/work-with-us/boostrer_2.webp",
    avatar: "/images/avatars/avatar12.webp",
    game: "League of Legends",
    username: "League Booster",
    review:
      "Since using the Boosting Market, my gaming experience has reached new heights. The ability to customize settings for each game has allowed me to maximize my hardware's potential, giving me an edge in competitive play. The real-time monitoring tools let me track performance metrics, and I've been able to maintain a consistent frame rate even in the most demanding scenarios.",
    stars: 5,
  },
  {
    image: "/images/work-with-us/booster_3.webp",
    avatar: "/images/avatars/avatar13.webp",
    game: "League of Legends",
    username: "League Booster",
    review:
      "The Boosting Market has transformed my gaming setup. The automatic optimizations based on my hardware have saved me hours of manual tweaking. It's refreshing to see improvements across all genres, from RPGs to FPS titles. I can now enjoy my favorite games without worrying about occasional stutters or crashes, making my gaming sessions much more enjoyable.",
    stars: 5,
  },
]);

const breakpoints = {
  200: {
    slidesPerView: 1.1,
  },
  600: {
    slidesPerView: 1.1,
  },
  768: {
    slidesPerView: 1.25,
  },
  1024: {
    slidesPerView: 1.25,
  },
  1440: {
    slidesPerView: 1.5,
  },
  1900: {
    slidesPerView: 2.15,
  },
  2000: {
    slidesPerView: 2.5,
  },
  2400: {
    slidesPerView: 3.25,
  },
  2800: {
    slidesPerView: 3.25,
  },
};

const onSwiper = (swiper) => {
  swiperRef.value = swiper;
};

const onSlideChange = () => {};
</script>

<style lang="scss">
.testimonial_card_container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: calc(100% + 100px);
  position: relative;
  @media screen and (min-width: 1441px) {
    width: calc(100% + 120px);
  }
  @media screen and (max-width: 850px) {
    width: calc(100% + 50px);
  }
  @media screen and (max-width: 768px) {
    width: calc(100% + 16px);
    &::after {
      display: none;
    }
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100px;
    z-index: 9;
    right: 0;
    background: linear-gradient(
      270deg,
      rgba(0, 0, 0, 0.85) 0%,
      rgba(0, 0, 0, 0.6) 20%,
      rgba(0, 0, 0, 0.3) 60%,
      rgba(0, 0, 0, 0) 100%
    );
  }
}
</style>
